import { getHeaderModel } from "../../../../api/headerApi";
import { HeaderData } from "../../../../api/headerApi.types";
import { useQuery } from "@tanstack/react-query";

export const useHeaderModel = (currentPageId: string, initialData?: HeaderData) => {
  const isSSR = typeof window === "undefined" || !!(window as any).__isSSR;
  const hasInitialData = initialData != null;

  return useQuery({
    queryKey: ["redesign-header", currentPageId],
    queryFn: () => getHeaderModel(currentPageId),
    staleTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
    // SSR and hydrated pages already have server-fetched nav data — don't refetch on mount.
    enabled: !isSSR && !hasInitialData,
    initialData,
  });
};